<div class="w-full h-full flex flex-col gap-6 p-4" [@animate]="{value:'*',params:{scale:'.2',delay:'200ms'}}">
    <div class="rounded-md shadow-md p-4 w-full bg-white flex flex-col gap-4">

        <div class="h-12 flex flex-row gap-4 items-center">
            <div class="text-3xl font-bold">
                <mat-icon class="text-3xl align-middle mr-2">cloud_download</mat-icon>
                {{ 'RDU Manager' | translate }}
            </div>
        </div>

        <!-- Login Form -->
        <div *ngIf="!rduManagerAppFileName" class="flex flex-col gap-4">
            <div *ngIf="!isTrackgpsProfile" class="text-sm text-slate-500">
                {{ 'Please enter your credentials to access the RDU Manager download.' | translate }}
            </div>

            <div *ngIf="!isTrackgpsProfile" class="flex flex-col gap-3 max-w-sm">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Username' | translate }}</mat-label>
                    <input matInput [(ngModel)]="username" [disabled]="isLoading" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Password' | translate }}</mat-label>
                    <input matInput type="password" [(ngModel)]="password" [disabled]="isLoading"
                        (keydown.enter)="authenticate()" />
                </mat-form-field>
            </div>

            <div *ngIf="errorMessage"
                class="flex flex-row items-center gap-2 px-3 py-2 bg-red-50 border-l-4 border-red-500 rounded text-sm text-red-700">
                <mat-icon class="text-base w-4 h-4 text-red-600">error</mat-icon>
                <span>{{ errorMessage }}</span>
            </div>

            <div>
                <button (click)="authenticate()"
                    [disabled]="isLoading || (!isTrackgpsProfile && (!username || !password))"
                    class="text-white px-4 py-2 bg-tachosafe-500 font-bold disabled:bg-slate-300 flex items-center gap-2">
                    <mat-icon>login</mat-icon>
                    {{ (isLoading ? 'Authenticating...' : 'Download') | translate }}
                </button>
            </div>
        </div>

        <!-- Download Section -->
        <div *ngIf="rduManagerAppFileName" class="flex flex-col gap-4">
            <div class="text-sm text-slate-500">
                {{ 'Click the button below to download the RDU Manager application.' | translate }}
            </div>

            <div
                class="flex flex-row items-center gap-2 px-3 py-2 bg-blue-50 border-l-4 border-blue-500 rounded text-sm text-blue-800">
                <mat-icon class="text-base w-4 h-4 text-blue-600">insert_drive_file</mat-icon>
                <span class="font-mono">{{ rduManagerAppFileName }}</span>
            </div>

            <div>
                <button (click)="downloadFile()"
                    class="text-white px-4 py-2 bg-tachosafe-500 font-bold disabled:bg-slate-300 flex items-center gap-2">
                    <mat-icon>cloud_download</mat-icon>
                    {{ 'Download RDU Manager' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>